import React from "react";
import Top from "../../Top";
import Left from "../../Left";
// import { Button, Grid } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

import AddGuards from "./AddGuards";
// End

function EditGuardNew() {
  // const navigate = useNavigate();
  const { egid } = useParams();

  // For Modal
  const [open] = React.useState(false);

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  // End

  return (
    <>
      <Top />
      <Left />

      <AddGuards name={egid} />
    </>
  );
}

export default EditGuardNew;
